import CardActionSharePost from "./card-action-share-post";

export default CardActionSharePost;